module.exports = __webpack_public_path__ + "images/emoji/grin.417f947f4c8632e69c22.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/grin.png
// module id = 5/sx
// module chunks = 1